export const rowDataDeFormatter = (row) => {
    let attributes = Object.entries(row.attributes).map(([key, value]) => {
        return {name: key, value: value}
    })
    return { id: row.id, attributes: attributes }
}

export const rowsDataFormatter = (rows) => {
    let arrOfRows = [];
    rows.forEach(row => {
        let finalObjAttr = {};
        row.attributes.forEach(attr => {
            //key is part_channel_alias
            finalObjAttr[`attributes_${attr.channel}_${attr.alias}`] = attr.value;
        })
        row.stocks.forEach(stock => {
            const warehouseID = stock.type === 'warehouse' ? stock.data.warehouseID : null;
            //key is part_warehouseID_stockType
            finalObjAttr[`stocks_${warehouseID}_${stock.type}`] = stock.data.quantity;
        })
        arrOfRows.push({ id: row.id, attributes: finalObjAttr})
    })
    return arrOfRows;
}

export const flatData = (arr, key) => {
    const res = [];
  
    const recursion = (data) => {
      data.forEach((item) => {
        if (!item.hasOwnProperty(key)) {
          res.push(item);
        }
        if (item[key]) {
            recursion(item[key]);
        }
      });
    };
    recursion(arr);

    return res
  }